import { faTriangleExclamation } from '@fortawesome/pro-regular-svg-icons';

import Icon from 'components/Icon';

import GithubDashboard from './GitHubDashboard';
import DashboardSkeleton from './DashboardSkeleton';
import { useQuery } from 'react-query';

import styles from './dashboard-skeleton.module.scss';

type GitHubDashboardContainerProps = {
  onSignOut: () => void;
};

export default function GitHubDashboardContainer({ onSignOut }: GitHubDashboardContainerProps) {
  const { data, error, isError, isLoading, dataUpdatedAt } = useQuery({
    queryKey: ['dashboard']
  });

  if (isLoading) {
    return <DashboardSkeleton />;
  }

  if (error && !data) {
    return (
      <div className={styles.errorWrapper}>
        <div className={styles.error} role="alert">
          <Icon className={styles.errorIcon} icon={faTriangleExclamation} color="auroraAmber" size={32} />
          <h2 className={`${styles.errorTitle} font-display`}>Can&apos;t reach the dashboard service</h2>
          <p className={styles.errorText}>
            We&apos;ll retry automatically and refresh the dashboard when it reconnects.
          </p>
          <button className={styles.signOutLink} type="button" onClick={onSignOut}>
            Sign out and use a different API key
          </button>
        </div>
      </div>
    );
  }

  return <GithubDashboard data={data} stale={isError} lastUpdated={dataUpdatedAt} />;
}
